export enum OrderStatus {
  ORDERED = "os111111-1111-1111-1111-111111111111",
  COMPLETE = "os555555-5555-5555-5555-555555555555",
  CANCELLED = "os666666-6666-6666-6666-666666666666",
}

export const OrderStatusInfo = {
  [OrderStatus.ORDERED]: { code: "ordered", name: "Ordered" },
  [OrderStatus.COMPLETE]: { code: "complete", name: "Complete" },
  [OrderStatus.CANCELLED]: { code: "cancelled", name: "Cancelled" },
} as const;

export const getOrderStatusCode = (value: OrderStatus): string =>
  OrderStatusInfo[value].code;
export const getOrderStatusName = (value: OrderStatus): string =>
  OrderStatusInfo[value].name;
